/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Createaccountdesc2Inputs */

const zh_auth_createaccountdesc2 = /** @type {(inputs: Auth_Createaccountdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`填写以下信息创建您的账户`)
};

const en_auth_createaccountdesc2 = /** @type {(inputs: Auth_Createaccountdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your information below to create your account`)
};

const es_auth_createaccountdesc2 = /** @type {(inputs: Auth_Createaccountdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa tu información para crear tu cuenta`)
};

/**
* | output |
* | --- |
* | "Enter your information below to create your account" |
*
* @param {Auth_Createaccountdesc2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_createaccountdesc2 = /** @type {((inputs?: Auth_Createaccountdesc2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Createaccountdesc2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_createaccountdesc2(inputs)
	if (locale === "en") return en_auth_createaccountdesc2(inputs)
	return es_auth_createaccountdesc2(inputs)
});
export { auth_createaccountdesc2 as "auth_createAccountDesc" }